export enum RoleValue {
  ADMIN = 'admin',
  GOTIVA_MEMBER = 'gotiva member',
  ARTIST = 'artist',
}
